export const oidcConfig = {
  authority: `https://${process.env.REACT_APP_COGNITO_BASE_DOMAIN}.auth.${process.env.REACT_APP_COGNITO_REGION}.amazoncognito.com`,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
  redirect_uri: window.location.origin,
  response_type: 'code',
  scope: "openid profile email",

  metadata: {
    issuer: `https://cognito-idp.${process.env.REACT_APP_COGNITO_REGION}.amazonaws.com/${process.env.REACT_APP_USER_POOL_ID}`,
    authorization_endpoint: `https://${process.env.REACT_APP_COGNITO_BASE_DOMAIN}.auth.${process.env.REACT_APP_COGNITO_REGION}.amazoncognito.com/oauth2/authorize`,
    token_endpoint: `https://${process.env.REACT_APP_COGNITO_BASE_DOMAIN}.auth.${process.env.REACT_APP_COGNITO_REGION}.amazoncognito.com/oauth2/token`,
    userinfo_endpoint: `https://${process.env.REACT_APP_COGNITO_BASE_DOMAIN}.auth.${process.env.REACT_APP_COGNITO_REGION}.amazoncognito.com/oauth2/userInfo`,
    end_session_endpoint: `https://${process.env.REACT_APP_COGNITO_BASE_DOMAIN}.auth.${process.env.REACT_APP_COGNITO_REGION}.amazoncognito.com/logout`,
  },

  signoutRedirectArgs: {
    client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
    post_logout_redirect_uri: window.location.origin,
  },
};